import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';


import * as filters from '../../filters/index'
import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-applicationinfo',
  templateUrl: './ApplicationInfo.component.html'
})
export class ApplicationInfoComponent implements OnInit {

    userInfo: ent.UserInfo;
    appConfig: ent.AppConfig;
    constructor(private authenticationService: serv.AuthenticationService, private router: Router, private configService: serv.ConfigService ) 
    {
        this.appConfig = this.configService.appConfig;
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus()){
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
    }

}